export enum VatDeclarationStatus {
  Draft = 'draft',
  OverduePayment = 'overdue-payment',
  OverdueSubmission = 'overdue-submission',
  Paid = 'paid',
  Pending = 'pending',
  ReadyToPay = 'ready-to-pay',
  ReadyToSubmit = 'ready-to-submit',
  SubmissionFailed = 'submission-failed',
}
